import React from "react";

import styles from "./index.module.scss";
import { useDevice } from "../../../contexts/deviceContext";

interface OwnProps {
  iconDesktop: string;
  iconMobile: string;
  mainText: string;
  subText: string;
}

type Props = OwnProps;

const NoResult: React.NamedExoticComponent<Props> = React.memo(
  ({ iconDesktop, iconMobile, mainText, subText }) => {
    const device = useDevice();

    return (
      <div className={styles.noResult}>
        <div className={styles.icon}>
          <img src={device === "mobile" ? iconMobile : iconDesktop} />
        </div>
        <div className={styles.text}>
          <div className={styles.mainText}>{mainText}</div>
          <div className={styles.subText}>{subText}</div>
        </div>
      </div>
    );
  },
);

export { NoResult };
